import {useEffect, useState} from "react";


const push_notifications = `wss://${process.env.REACT_APP_NOTIFICATION_API_ID}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}/`

const dashboard = `wss://${process.env.REACT_APP_DASHBOARD_API_ID}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}/`
const region = process.env.REACT_APP_REGION
const entra_app_id = process.env.REACT_APP_ENTRA_APP_ID
const entra_authority = process.env.REACT_APP_ENTRA_AUTHORITY
const wallboard_api = `https://${process.env.REACT_APP_WALLBOARD_API_ID}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}`
export {
     push_notifications,
    region,
    entra_authority,
    entra_app_id,
    dashboard,
    wallboard_api
}